import React from 'react';
import Text from 'shared/components/text';
import Icon from 'shared/components/icon';

interface Props {
  deadline?: string;
}

const CollegeCardDeadlinePassedText = ({deadline}: Props) => (
  <div className="shared-college-card-status-text-deadline-passed">
    <Icon className="shared-college-card-status-text-default-flag" iconType="flag" />
    <Text weight={6} inline>
      {deadline ? deadline : 'The'} deadline to earn has passed
    </Text>
  </div>
);

export default CollegeCardDeadlinePassedText;
